import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Assessment from "@/pages/Assessment";
import Blueprint from "@/pages/Blueprint";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminSetPassword from "@/pages/AdminSetPassword";
import Careers from "@/pages/Careers";
import CrmEntry from "@/pages/CrmEntry";
import Unsubscribe from "@/pages/Unsubscribe";
import { ThemeManager } from "@/components/ThemeManager";
import { useIframeResize } from "@/hooks/useIframeResize";
import { isPreviewEnv } from "@/lib/env";

function App() {
  useIframeResize();
  // On the Preview environment only, prefix the document title so the TEST
  // context is obvious even from the browser tab. Production is untouched.
  useEffect(() => {
    if (isPreviewEnv()) {
      document.title = "TEST | TeamBuilder AI by Rendeavored";
    }
  }, []);
  return (
    <div className="App dark">
      <BrowserRouter>
        <ThemeManager />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/assessment" element={<Assessment />} />
          <Route path="/crm/assessment/:prospectId" element={<Assessment />} />
          <Route path="/blueprint/:id" element={<Blueprint />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/setup" element={<AdminSetPassword mode="setup" />} />
          <Route path="/admin/reset" element={<AdminSetPassword mode="reset" />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/crm" element={<CrmEntry />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/unsubscribe/:token" element={<Unsubscribe />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors theme="dark" />
    </div>
  );
}

export default App;
